import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export default class BlockMouseEvent {
  constructor() {
    _defineProperty(this, "hovered", {
      content: false
    });
    _defineProperty(this, "clicked", {
      content: false
    });
  }
  setHovered(isHovered) {
    this.hovered.content = !!isHovered;
    return this;
  }
  makeHovered() {
    this.setHovered(true);
    return this;
  }
  makeNotHovered() {
    this.setHovered();
    return this;
  }
  setClicked(isClicked) {
    this.clicked.content = !!isClicked;
    return this;
  }
  makeClicked() {
    this.setClicked(true);
    return this;
  }
  makeNotClicked() {
    this.setClicked();
    return this;
  }
  isHovered() {
    return this.hovered.content;
  }
  isClicked() {
    return this.clicked.content;
  }
}